export const setSeparator = (variable: unknown, value: string | number, separator: string, defaultSeparator = ",") =>
  variable === value ? separator : defaultSeparator;
